// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__3-cHm","text":"Footer_text__2Gaiq","actions":"Footer_actions__1Caw_","copy":"Footer_copy__3T3nf"};